import KaKaoIcon from '@/assets/icons/More/payment_icon_yellow_large 1.svg?react';
import { DialogContent } from '@/components/atoms/Dialog';
import { useLayoutEffect, useRef, useState } from 'react';
import { motion } from 'framer-motion';
import ChangeBillCard from '@/pages/More/ChangeBillCard';
import ChangeBillKakao from '@/pages/More/ChangeBillKakao';
import type { MembershipChannel } from '@/utils/pending-subscription';

export type MembershipPaymentDialogMode = 'subscription' | 'pendingSubscription';

interface NewPaymentDialogProps {
  isPrePayment?: boolean;
  subscriptionNo: number;
  paymentAmount: number;
  setBillDialogOpen: (open: boolean) => void;
  mode?: MembershipPaymentDialogMode;
  pendingSubscriptionChannel?: MembershipChannel;
  onPendingSubscriptionSuccess?: () => void;
}
const NewPaymentDialog = ({
  isPrePayment,
  subscriptionNo,
  paymentAmount,
  setBillDialogOpen,
  mode = 'subscription',
  pendingSubscriptionChannel,
  onPendingSubscriptionSuccess,
}: NewPaymentDialogProps) => {
  const [changeBillOptions, setChangeBillOptions] = useState<'KAKAO_PAY' | 'CARD'>('KAKAO_PAY');
  const contentRef = useRef<HTMLDivElement>(null);
  const [contentHeight, setContentHeight] = useState<number | 'auto'>('auto');

  useLayoutEffect(() => {
    const el = contentRef.current;
    if (!el) return;
    setContentHeight(el.offsetHeight);
    const observer = new ResizeObserver(() => {
      setContentHeight(el.offsetHeight);
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  const billProps = {
    isPrePayment,
    subscriptionNo,
    paymentAmount,
    setBillDialogOpen,
    mode,
    pendingSubscriptionChannel,
    onPendingSubscriptionSuccess,
  };
  const renderChangeBillForm = () => {
    switch (changeBillOptions) {
      case 'KAKAO_PAY':
        return <ChangeBillKakao {...billProps} />;
      case 'CARD':
        return <ChangeBillCard {...billProps} />;
      default:
        return <ChangeBillKakao {...billProps} />;
    }
  };
  return (
    <DialogContent noCloseBtn className="w-full max-w-[580px]">
      <motion.div
        initial={false}
        animate={{ height: contentHeight }}
        transition={{ duration: 0.28, ease: [0.4, 0, 0.2, 1] }}
        style={{ overflow: 'hidden' }}
      >
        <div ref={contentRef} className="flex flex-col items-start gap-8">
          <div className="flex w-full flex-col gap-3">
            <h1 className="text-gr-900 Body1S16">결제 수단</h1>
            <div className="flex w-full items-start justify-between">
              <div className="pt-[11px] text-gr-800 Body2M16">변경할 결제 수단</div>
              <div className="relative flex h-[46px] overflow-hidden rounded-[12px] bg-gr-100 p-[6px]">
                {/* 이동하는 흰색 배경 */}
                <motion.div
                  className="absolute left-[6px] top-[6px] h-[34px] w-[140px] rounded-[8px] bg-white shadow"
                  animate={{ x: changeBillOptions === 'KAKAO_PAY' ? 0 : '100%' }}
                  transition={{ type: 'spring', stiffness: 300, damping: 30 }}
                />
                {/* 카카오페이 */}
                <button
                  type="button"
                  className="relative z-10 flex w-[140px] cursor-pointer items-center justify-center gap-[6px] rounded-[8px]"
                  onClick={() => setChangeBillOptions('KAKAO_PAY')}
                >
                  <KaKaoIcon />
                  <span className="text-gr-700 Body5M14">카카오페이</span>
                </button>
                {/* 카드결제 */}
                <button
                  type="button"
                  className="relative z-10 flex w-[140px] cursor-pointer items-center justify-center gap-[6px] rounded-[8px]"
                  onClick={() => setChangeBillOptions('CARD')}
                >
                  <span className="text-gr-700 Body5M14">일반 카드</span>
                </button>
              </div>
            </div>
          </div>
          <div className="w-full">{renderChangeBillForm()}</div>
        </div>
      </motion.div>
    </DialogContent>
  );
};

export default NewPaymentDialog;
